document.addEventListener('DOMContentLoaded', function () {
  const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.querySelectorAll('.card-wrapper').forEach(function (card) {
    const container = card.querySelector('.card__media');
    if (!container) return;

    const mainImage = container.querySelector('.media > img');

    const hoverSlides = Array.from(
      container.querySelectorAll('.card__media-hover-slides .hover-slide')
    );

    if (!mainImage || !hoverSlides.length) return;

    // İlk görsel + ürünün diğer görselleri
    const slides = [mainImage, ...hoverSlides];

    let currentIndex = 0;

    function showSlide(index) {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));

      hoverSlides.forEach(function (slide, i) {
        slide.classList.toggle('active', i + 1 === currentIndex);
      });

      mainImage.style.opacity = currentIndex === 0 ? '1' : '0';
    }

    // ==================================================
    // MASAÜSTÜ
    // Mouse görsel üzerinde hareket ettikçe fotoğraf değişir
    // ==================================================

    card.addEventListener('mousemove', function (event) {
      if (!isDesktop.matches) return;

      const rect = container.getBoundingClientRect();

      if (
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom
      ) {
        return;
      }

      const x = event.clientX - rect.left;
      const ratio = x / rect.width;

      const index = Math.min(
        Math.floor(ratio * slides.length),
        slides.length - 1
      );

      showSlide(index);
    });

    card.addEventListener('mouseleave', function () {
      if (!isDesktop.matches) return;

      showSlide(0);
    });
// ==================================================
// MOBİL
// Gerçek yatay swipe galerisi
// ==================================================

if (!isDesktop.matches) {
  const media = container.querySelector('.media');
  const productLink = card.querySelector('a[href*="/products/"]');

  if (media && productLink) {
    const mobileSlider = document.createElement('div');
    mobileSlider.className = 'card-mobile-slider';

    slides.forEach(function (image) {
      const clone = image.cloneNode(true);

      clone.classList.remove('active', 'hover-slide');
      clone.removeAttribute('style');
      clone.classList.add('card-mobile-slider__image');

      mobileSlider.appendChild(clone);
    });

    let scrollStart = 0;
    let didSwipe = false;

    mobileSlider.addEventListener(
      'touchstart',
      function () {
        scrollStart = mobileSlider.scrollLeft;
        didSwipe = false;
      },
      { passive: true }
    );

    mobileSlider.addEventListener(
      'scroll',
      function () {
        if (Math.abs(mobileSlider.scrollLeft - scrollStart) > 10) {
          didSwipe = true;
        }
      },
      { passive: true }
    );

    mobileSlider.addEventListener('click', function (event) {
      if (didSwipe) {
        event.preventDefault();
        didSwipe = false;
        return;
      }

      window.location.href = productLink.href;
    });

    media.appendChild(mobileSlider);
  }
}
    showSlide(0);
  });
});